if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.documentElement.classList.remove('product-media-modal-open');
        document.body.classList.remove('product-media-modal-open');
      }

      show(opener) {
        super.show(opener);
        document.documentElement.classList.add('product-media-modal-open');
        document.body.classList.add('product-media-modal-open');
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        this.querySelectorAll(`[data-media-id]`).forEach((element) => {
          if (element.getAttribute('data-media-id') === mediaId) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (isMobile) {
          const container = this.querySelector('[role="document"]');

          if (container) {
            container.scrollTop = 0;
            container.scrollLeft = 0;
          }

          /*
            Important:
            No scrollIntoView on real mobile.
            Dawn's default scrollIntoView makes tall images appear zoomed/cropped.
          */
          return;
        }

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}